const GOOGLE_MEET = 1;
const MICROSOFT_TEAMS = 2;
const BLACKBOARD_COLLABORATE = 3;

const getProviderName = (id) => {
  return {
    [GOOGLE_MEET]            : 'Google Meet',
    [MICROSOFT_TEAMS]        : 'Microsoft Teams',
    [BLACKBOARD_COLLABORATE] : 'Blackboard Collaborate'
  }[id];
};

const getIconByProviderId = (id) => {
  return {
    [GOOGLE_MEET]            : require('~/assets/img/webconference/meet_icon.svg'),
    [MICROSOFT_TEAMS]        : require('~/assets/img/webconference/teams_icon.svg'),
    [BLACKBOARD_COLLABORATE] : require('~/assets/img/webconference/collaborate_icon_new.svg')
  }[id];
};

const getMobileIconByProviderId = (id) => {
  return {
    [GOOGLE_MEET]            : 'mdi-google',
    [MICROSOFT_TEAMS]        : 'mdi-microsoft-teams',
    [BLACKBOARD_COLLABORATE] : 'mdi-video-outline'
  }[id];
};

module.exports = {
  GOOGLE_MEET,
  MICROSOFT_TEAMS,
  BLACKBOARD_COLLABORATE,
  getIconByProviderId,
  getMobileIconByProviderId,
  getProviderName
};
